import "./Source";
import "System/Promises";
import { RequestFailedError, XHRError } from '../errors';

/** @namespace Data */
NS("Data");

/**
 * @class
 * @extends Data.Source
 * @extends System.Promises
 */
Data.ServerSource = Class(Data.Source, System.Promises, /** @lends Data.ServerSource.prototype */ {
    url: null,

    fields: [],
    names: {},

    initialize(url)
    {
        if (url) {
            this.url = url;
        }

        this.Parent();
    },

    'get'(options, callback)
    {
        return this.call("get", options, callback);
    },

    count(options, callback)
    {
        return this.call("count", options, callback);
    },

    find(options, callback)
    {
        return this.call("find", options, callback);
    },

    page(options, callback) {
        return this.call("page", options, callback);
    },
    /**
     * @param item
     * @param [callback]
     * @param [options] - additional params
     * @returns {*}
     */
    insert(item, callback, options)
    {
        return this.call("insert", {
            item: JSON.stringify(item),
            ...options
        }, callback, "POST");
    },
    /**
     * @param item
     * @param [callback]
     * @param [options] - additional params
     * @returns {*}
     */
    update(item, callback, options)
    {
        return this.call("update", {
            item: JSON.stringify(item),
            ...options
        }, callback, "POST");
    },

    remove(options, callback)
    {
        return this.call("remove", options, callback, "POST");
    },
    /**
     * @param item
     * @param [callback]
     * @param [options] - additional params
     * @returns {*}
     */
    save(item, callback, options)
    {
        return this.call("save", {
            item: JSON.stringify(item),
            ...options
        }, callback, "POST");
    },

    getDocument(options, callback)
    {
        return this.call("getDocument", options, callback);
    },

    findDocuments(options, callback)
    {
        return this.call("findDocuments", options, callback);
    },

    pageDocuments(options, callback)
    {
        return this.call("pageDocuments", options, callback);
    },
    /**
     * @param item
     * @param [callback]
     * @param [options] - additional params
     * @returns {*}
     */
    insertDocument(item, callback, options)
    {
        return this.call("insertDocument", {
            item: JSON.stringify(item),
            ...options
        }, callback, "POST");
    },
    /**
     * @param item
     * @param [callback]
     * @param [options] - additional params
     * @returns {*}
     */
    updateDocument(item, callback, options)
    {
        return this.call("updateDocument", {
            item: JSON.stringify(item),
            ...options
        }, callback, "POST");
    },

    removeDocument(options, callback)
    {
        return this.call("removeDocument", options, callback, "POST");
    },

    saveDocument(item, callback, options)
    {
        return this.call("saveDocument", {
            item: JSON.stringify(item),
            ...options
        }, callback, "POST");
    },
    /**
     * @param {string} name API action name
     * @param {Object|Function} [options] Request options or callback function.
     * @param {Function} [callback] Callback function.
     * @param {string} [method=GET] Request method.
     * @returns {Promise}
     *
     * @throws RequestFailedError
     */
    async call(name, options, callback, method = 'GET')
    {
        if (_.isFunction(options)) {
            callback = options;
            options = {};
        }

        try {
            const { success, data, message } = await this.addPromise(
                Util.Object.hash({
                    url: this.url + name,
                    options,
                    method
                }),
                Xhr.call(this.url + name, options, noop, method)
            );

            if (_.isFunction(callback)) {
                if (success) {
                    callback(data);
                } else {
                    callback(null, { success, data, message });
                }
            }

            assert(success, message, RequestFailedError);

            return data;
        } catch (err) {
            if (err instanceof XHRError) {
                let message

                if (err.response) {
                    try {
                        message = JSON.parse(err.response).message
                    } catch (e) {}
                }
                if (!message) message = 'API Request failed: ' + err.message

                throw new RequestFailedError(message)
            } else {
                throw err
            }
        }
    }
});
